document.addEventListener('DOMContentLoaded', function() {
    const currentLang = document.querySelector('.languageSelector .active');
    const langMenu = document.querySelector('.languageMenu');

    if (!currentLang || !langMenu) return;

    currentLang.addEventListener('click', function(event) {
        event.preventDefault();
        langMenu.classList.toggle('show');
        currentLang.classList.toggle('rotate');
    });

    // Close the language menu when clicking outside
    document.addEventListener('click', function(event) {
        if (!langMenu.contains(event.target) && !currentLang.contains(event.target)) {
            langMenu.classList.remove('show');
            currentLang.classList.remove('rotate');
        }
    });
});